/* global youbora, akamai */
function createYouboraPlugin (player, config) {
  youbora.Log.logLevel = youbora.Log.Level.DEBUG
  return new Promise(function (resolve) {
    player.youboraPlugin = new youbora.Plugin(config, new youbora.adapters.AkamaiAmp(player))
    resolve(player.youboraPlugin)
  })
}
akamai.amp.AMP.registerPlugin('youbora', createYouboraPlugin)
